// libs
import { connect } from 'react-redux';

// components
import APlusContent from 'shared/layouts/DetailsPage/components/ProductInfo/components/APlusContent/Mobile/APlusContent';

// redux store
import {
  getHeroImageV3,
  getProductId,
  getHeroImageData,
  getHeroImageDataAPIError,
  getAPlusContentAPIStatus,
} from 'shared/store/details/selectors';

// services
import { getAPlusContent } from 'shared/store/details/services';

const mapStateToProps = (state: any) => {
  return {
    heroImageURL: getHeroImageV3(state),
    productId: getProductId(state),
    content: getHeroImageData(state),
    isError: getHeroImageDataAPIError(state),
    isFetched: getAPlusContentAPIStatus(state),
  };
};

const mapDispatchToProps = {
  getAPlusContent,
};

export default connect(mapStateToProps, mapDispatchToProps)(APlusContent);
